<template>
  <div class="managerMain">
    <el-header style="background: #444;width: 100%;">
      <div style="height: 60px;">
        <img :src="logoUrl" alt="" style="height: 100%;">
      </div>
    </el-header>
    <div style="eight: 80px;padding-top: 15px;box-sizing: border-box;width: 100%;padding-left: 30px;padding-right: 30px;">
      <el-menu :default-active="activeTab" mode="horizontal" @select="changeTab">
        <el-menu-item index="clientInformationForm">提交记录</el-menu-item>
        <el-menu-item index="invitationClientManage">白名单</el-menu-item>
        <el-menu-item index="agendaImage">议程图片设置</el-menu-item>
        <el-menu-item index="dataAggregation">数据汇总</el-menu-item>
      </el-menu>
    </div>
    <div style="flex: 5;overflow: auto">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import logoUrl from '@/assets/logo.png'

export default {
  name: "managerMain",
  data() {
    return {
      activeTab: "clientInformationForm",
      logoUrl
    }
  },
  methods: {
    changeTab(tab, event) {
      this.$router.push({name: tab})
    }
  },
  mounted() {
    this.activeTab = this.$route.name
  }
}
</script>

<style lang="less">
.managerMain {
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  thead tr th, .el-table th.el-table__cell  {
    background-color: #f5e0c0;
    color: #333;
  }

  .el-table--border th,
  .el-table--border td {
    text-align: center;
  }

  > div {
    width: 100%;
    padding-right: 30px;
    padding-left: 30px;
    box-sizing: border-box;

    &:first-child {
      padding-right: 0;
      padding-left: 0;
    }
  }

  .el-menu.el-menu--horizontal {
    border-bottom: 1px solid #86560f;
  }

  .el-menu--horizontal > .el-menu-item {
    float: left;
    height: 36px;
    line-height: 36px;
    margin: 0;
    border-bottom: 2px solid transparent;
    color: #909399;
    font-size: 18px;
    font-weight: bold;
    min-width: 200px;
    text-align: center;
  }

  .el-menu--horizontal > .el-menu-item.is-active {
    border: 1px solid #86560f;
    border-bottom: 2px solid #86560f;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    color: #86560f;
  }
  
  .button-border {
    border: 1px solid #86560f;
    background: none;
    color: #86560f;
  }
}
</style>
